/// <reference path="../Init.ts"/>
namespace RS.ExternalHelp
{
    @HasCallbacks
    class DocDownload extends Plugin
    {

        protected static singleDocButtonID = "singleDocGen";
        protected static multipleDocButtonID = "multiDocGen";
        protected static divID = "docGenerator";

        protected _locale: string;
        protected _locale_codes = [ "bg_BG","ca_ES","cs_CZ","da_DK","de_DE","el_GR","en_GB","en_US","es_ES",
        "et_EE","fi_FI","fr_CA","fr_FR","hr_HR","hu_HU","it_IT","ja_JP","lt_LT","lv_LV","nl_NL","no_NO","pl_PL",
        "pt_PT","ro_RO","ru_RU","sk_SK","sl_SI","sr_RS","sv_SE","tr_TR" ];

        public onPageLoaded(page: IPage)
        {
            this._locale = page.localeCode;
            const showButton = URL.getParameterAsBool("generateDoc", false);
            if (document.getElementById(DocDownload.divID))
            {
                this.showButton(showButton);
                document.getElementById(DocDownload.singleDocButtonID).onclick = this.generateThisDoc.bind(this);
                document.getElementById(DocDownload.multipleDocButtonID).onclick = () => { this.generateAllDocs(); };
            }
            if (URL.getParameter("dlDoc"))
            {
                this.generateThisDoc();
            }
        }

        private getGameName(): string {
            const url = window.location.href;
            const parts = url.split('/');
            let gameName = "";
            //checks if there are at least 3 slashes in the url and takes the 4th part, which is the game name
            if (parts.length >= 4) {
                gameName = parts[4];
            }
            return gameName;
        }

        @Callback
        private async generateAllDocs()
        {
            const url = window.location.href;
            const dlParam = "&dlDoc=true";

            //Sets the prompt for a user to input or edit locales
            let prompt = window.prompt("Edit this list to add or remove locales (seperate by comma); Please wait for document generator to finish.",
                this._locale_codes.join());

            if (prompt == "" || prompt == null)
            {
                Log.debug("No locales given!");
            }
            else
            {
                //Loops through list created by the prompt
                for (const locale of this._locale_codes)
                {
                    await new Promise((f) => setTimeout(f, 500));
                    const newUrl = url.replace(this._locale, locale).concat(dlParam);
                    let req = new XMLHttpRequest();
                    req.open('GET', newUrl);
                    req.onload = async () =>
                    {
                        if (req.status != 200)
                        {
                            Log.debug(req.statusText + "Locale given: " + locale + "doesn't correspond to a viable url");
                            return;
                        }
                        else
                        {
                            let win = window.open(newUrl);
                            await new Promise((f) => setTimeout(f, 500));
                            win.close();
                        }
                    }
                    req.send();
                }
            }
        }

        private generateThisDoc()
        {
            this.showButton(false);
            // create document
            const header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
                    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
                    "xmlns='http://www.w3.org/TR/REC-html40'>" +
                    document.head.innerHTML + "<body>";
            const footer = "</body></html>";
            const sourceHTML = header + document.getElementById("wrapper").innerHTML + footer;
            const source = 'data:application/vnd.ms-word;charset=utf-8,' + sourceHTML;
            // download document
            const blob = new Blob([ source ], { type: 'text/html' })
            this.saveBlob(blob, this.getGameName() + "-" + this._locale);
            this.showButton(true);
        }

        private saveBlob(b: Blob, loc: string)
        {
            const fileDownload = document.createElement("a");
            const fileRef = window.URL.createObjectURL(b);
            fileDownload.href = fileRef;
            fileDownload.download = loc + ".doc";
            fileDownload.click();
            window.URL.revokeObjectURL(fileRef);
        }

        private showButton(visible: boolean)
        {
            document.getElementById(DocDownload.divID).style.display = visible ? "" : "none";
        }
    }
    pluginRegistry.register(DocDownload);
}